import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col"
};
const _hoisted_2 = {
  class: "flex-center"
};
import Card from "@/modules/match/components/Card.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CardIncident',
  props: {
    liveIncident: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(EntityLink, {
        entity: __props.liveIncident.incident.team,
        disabled: "",
        class: "mb-2"
      }, null, 8, ["entity"]), _createElementVNode("div", _hoisted_2, [_createVNode(Card, {
        card: __props.liveIncident.incident.card,
        size: "large",
        class: "mr-2"
      }, null, 8, ["card"]), _createTextVNode(" " + _toDisplayString(__props.liveIncident.incident.player.shortName), 1)])]);
    };
  }
});